import { Injectable } from '@angular/core';
import { StockForSign } from '../../model/sign-stock/stock-for-sign';
import { SignStockEditRequest } from '../../model/sign-stock/sign-stock-edit-request';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from '../loading.service';
import { Router } from '@angular/router';
import { SnackService } from '../snack.service';
import { Observable } from 'rxjs';
import { _get, _post, DeserializeVoid } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class SignStockControllerRequestService {
  private static BASE_URL = '/sign-stock';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: SignStockEditRequest | number,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializeArray = (res) => res as StockForSign[];
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      SignStockControllerRequestService.BASE_URL,
      requestServices
    );
    this.post = _post(
      SignStockControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public stockForSignWithId(signId: number): Promise<StockForSign[]> {
    return this.get(`/sign/${signId}`, this.deserializeArray).toPromise();
  }

  public editStock(request: SignStockEditRequest): Promise<void> {
    return this.post('/edit-stock', request, DeserializeVoid).toPromise();
  }

  public transferOfferToProduction(signId: number): Promise<void> {
    return this.post(
      '/offer-stock-transfer',
      signId,
      DeserializeVoid
    ).toPromise();
  }

  public transferDirectOrderToProduction(signId: number): Promise<void> {
    return this.post(
      '/direct-order-stock-transfer',
      signId,
      DeserializeVoid
    ).toPromise();
  }
}
